

<div id="panel-card" style="">
  <div *ngFor="let item of control; let index = i"> 
      <p-card header="Advanced Card" subheader="Subheader" (click)="navegar(item.id)"  styleClass="ui-card-shadow">
          <p-header>
                <img  
                *ngIf="item.foto == null || item.foto.length === 0" 
                style="min-height: 300px; max-height: 300px; object-fit: cover;"  
                src="assets/img/no-hay-foto.png"
                >
                <img *ngIf="item.foto != null && item.foto.length > 0"  style="min-height: 300px; max-height: 300px; object-fit: cover;" 
                [src]="urlImagen + item.foto">
          </p-header>
          <div>{{item.nombre}}</div>
          <ng-container *ngIf="item.descripcion != null && item.descripcion.length > 0; else elseTemplate">
            <div>{{item.descripcion}}</div>
          </ng-container>
          <ng-template #elseTemplate>
            <div>Sin descripcíon</div>  
          </ng-template>
          
      </p-card>
  </div>
</div>

<div id="btn-add" (click)="createArticle()">
  Añadir articulo
</div>